import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { UserDto } from '../../models/user.dto';
import { useUpdateUserDataMutation } from '../../store/user/user.api';
import { LANGUAGE_OPTIONS } from '../../config/enums/Language';
import DropdownWithFilter from '../elements/dropdown-with-filter/dropdown-with-filter';
import chevronDown from '../../assets/icons/chevron-down.svg';
import './language-switcher.scss';

interface LanguageSwitcherProps {
   userData?: UserDto
   compact?: boolean
}

const LanguageSwitcher: FC<LanguageSwitcherProps> = ({
   userData, compact
}) => {
   const [updateUserData] = useUpdateUserDataMutation();
   const { i18n } = useTranslation();
   const [translate] = useTranslation(['common']);

   const onLanguageChange = (newLanguage: string) => {
      if (userData) {
         updateUserData({ ...userData, language: newLanguage });
      }
      i18n.changeLanguage(newLanguage);
   }

   const getLanguageLabel = ({ label, shortLabel }: typeof LANGUAGE_OPTIONS[number]) =>
      compact ? shortLabel : translate(label);

   const activeLanguage = i18n.resolvedLanguage?.split('-')[0] ?? i18n.language.split('-')[0];
   const selectedLanguage = LANGUAGE_OPTIONS.find(({ code }) => code === activeLanguage);

  return (
    <div className={`language-switcher ${compact ? 'language-switcher-compact' : ''}`}>
      <DropdownWithFilter
        items={LANGUAGE_OPTIONS}
        selectedValue={selectedLanguage ? getLanguageLabel(selectedLanguage) : activeLanguage.toUpperCase()}
        getMenuItemValue={getLanguageLabel}
        handleChange={({ code }) => onLanguageChange(code)}
        handleFilter={items => items}
        className='language-switcher-toggle'
        searchable={false}
        align='end'
        chevronIcon={chevronDown}
      />
    </div>
  )
}
export default LanguageSwitcher;
